import { Theme } from '@spoiler-alert/ui-library';

export default {
  addBracketDisabled: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  wrapper: {
    padding: '24px',
  },
  saveSettings: {
    display: 'flex',
    justifyContent: 'flex-end',
    boxShadow: `inset 0px 1px 0 0 ${Theme.borderColor}`,
    padding: '24px',
    width: '100%',
    '& button': {
      marginLeft: 8,
    },
  },
  title: {
    fontSize: 16,
    marginBottom: 0,
  },
  description: {
    fontSize: 14,
    marginTop: 0,
  },
  stepActionText: {
    fontSize: 14,
    fontWeight: 500,
  },
  stepActionContainer: {
    display: 'flex',
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 0',
    border: `1px dashed ${Theme.grey30}`,
    borderRadius: 4,
    cursor: 'pointer',
  },
  addBracket: {
    color: Theme.teal,
    fontSize: 16,
    fontWeight: 400,
  },
  select: {
    width: 299,
  },
  selectSmall: {
    width: 'auto',
  },
  disabled: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  anchorContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
  },
  bracketContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  subDescriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 24,
  },
  addExceptionButton: {
    padding: '12px 16px',
    width: 188,
    height: 12,
  },
  exceptionBracketContainer: {
    border: `1px solid ${Theme.grey30}`,
    borderRadius: 4,
    padding: 16,
    gap: 24,
    display: 'flex',
    flexDirection: 'column',
  },
  exceptionHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  trash: {
    width: 24,
    height: 24,
    cursor: 'pointer',
    fill: Theme.grey80,
    '&:hover': {
      fill: Theme.red,
    },
  },
  timelineContainer: {
    fontSize: 12,
    gap: 2,
  },
  madlibContainer: {
    marginTop: 20,
  },
  stepError: {
    borderColor: Theme.red,
  },
  errorIcon: {
    width: 16,
    height: 16,
    fill: Theme.red,
  },
  alertTriangle: {
    width: 16,
    height: 16,
    stroke: Theme.red,
  },
  alertWarning: {
    width: 16,
    height: 16,
    fill: Theme.teal,
  },
  fieldError: {
    color: Theme.red,
    fontSize: 12,
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    alignItems: 'center',
  },
  stepErrorInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    padding: 12,
    borderRadius: 4,
    fontSize: 14,
    background: Theme.red5,
  },
  stepInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    padding: 12,
    borderRadius: 4,
    background: Theme.teal5,
  },
  stepErrorContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  exceptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  noExceptionsContainer: {
    display: 'flex',
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 0',
    border: `1px dashed ${Theme.grey30}`,
    borderRadius: 4,
  },
  noExceptions: {
    color: Theme.grey80,
    fontSize: 14,
    fontWeight: 400,
  },
  timelineError: {
    borderRadius: 4,
    background: Theme.red5,
    padding: 12,
    fontSize: 14,
    marginBottom: 24,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& svg': {
      width: 16,
      height: 16,
      stroke: Theme.red,
    },
  },
};
